<template>
	<div class="appendageList-body">
		<div class="fx-header">
			<p>附属商品</p>
		</div>
		<Search :AuthorityList='AuthorityList' ref='searchRef' @handleSearch="handleSearch" />
		<div class="btn-box1">
			<el-button size="mini" type="primary" @click='addClick' v-if="AuthorityList['02_0004_0003_00']">新建</el-button>
			<el-button size="mini" type="primary" plain @click='delClick' v-if="AuthorityList['02_0004_0004_00']">删除</el-button>
		</div>
		<div class="table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				@row-dblclick='rowClick'
				:height="tableHeight"
				@selection-change="selectionChangeHandle"
			>
				<el-table-column
					type="selection"
					align="center"
					width="55">
				</el-table-column>
				<el-table-column
					prop="shopNames"
					label="门店"
					align="center"
					width="180">
					<template slot-scope="scope">
						{{scope.row.allShopFlag === 1 ? '全部' : scope.row.shopNames}}
					</template>
				</el-table-column>
				<el-table-column
					prop="shopNames"
					label="客户"
					align="center"
					width="180">
					<template slot-scope="scope">
						<div v-if="scope.row.allCustomerFlag === 1">全部</div>
						<div v-if="scope.row.cusCnt === 1 && scope.row.allCustomerFlag !== 1">{{scope.row.cusNames}}</div>
						<el-tooltip class="item" effect="dark" :content="scope.row.cusNames" placement="top-start">
							<div style="color: var(--fx-primary-color);text-decoration: underline;" v-if="scope.row.cusCnt > 1 && scope.row.allCustomerFlag !== 1">{{scope.row.cusCnt}}家</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column
					prop="type"
					label="生效条件"
					align="center"
					width="180">
					<template slot-scope="scope">
						{{scope.row.type === 1 ? '下单主商品' : '订单足额'}}
					</template>
				</el-table-column>
				<el-table-column
					prop="type"
					label="详情/主商品"
					align="center"
					width="180">
					<template slot-scope="scope">
						<span v-if="scope.row.type === 1">{{scope.row.mainProductName}}</span>
						<span v-else>订单满{{scope.row.orderMoneyRule}}元（{{scope.row.freightFlag === 1?'含运费':'不含运费'}})</span>
					</template>
				</el-table-column>
				<el-table-column
					label="附属商品"
					align="center"
					width="180">
					<template slot-scope="scope">
						<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
							<div style="display: flex;flex-direction: row;align-items: center;justify-content: center;" v-for="(item,index) in scope.row.detail" :key='index'>
								<div style="display: flex;align-items: center;justify-content: center;color: #FFFFFF; width: 18px;height: 18px;font-size: 12px;colro:#fff;background-color: #44BB60;border-radius: 2px;;" v-if="item.giftFlag ===1">赠</div>
								<span>{{item.appendageProductName}}({{item.spec}})</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					label="附属品数量"
					align="center"
					width="100">
					<template slot-scope="scope">
						<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
							<div style="display: flex;flex-direction: row;align-items: center;justify-content: center;" v-for="(item,index) in scope.row.detail" :key='index'>
								<span v-if='item.appendageType === 1 && item.type === 1'>{{item.mainQuantity}}:{{item.appendageQuantity}}</span>
								<span v-else>{{item.appendageQuantity}}</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="getDetail(scope.row.id)">查看</el-button>
						<el-button v-if="AuthorityList['02_0004_0004_00']" type='text' size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page-box">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handlePageChange"
				:current-page="page"
				:page-sizes="[20, 40, 60, 100, 300]"
				:page-size="size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="totalCount">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import Search from '@/components/appendageList/Search.vue'
export default {
	name: 'storage',
	components: {
		Search
	},
	data () {
		return {
			type: -1,
			keyword: '',
			customerIds: [],
			shopIds: [],
			ids: [],
			AuthorityList: {
				'02_0004_0001_00': false,
				'02_0004_0002_00': false,
				'02_0004_0003_00': false,
				'02_0004_0004_00': false
			},
			tableHeight: '100%',
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0
		}
	},
	created () {
		this.getAuthority('02_0004_0000_00')
		this.tableReload()
	},
	methods: {
		delClick () {
			if (this.ids.length === 0) {
				this.$message.error('请选择最少一条数据！')
				return false
			}
			let params = {
				ids: this.ids
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/appendage/deleteAppendage`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功！')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		addClick () {
			window.sessionStorage.removeItem('appendageId')
			this.$router.push('appendageDetail')
		},
		rowClick (row, column, event) {
			this.getDetail(row.id)
		},
		deleteItem (data) {
			let params = {
				ids: [data.id]
			}
			const logger = this.$fxLogger.createInfo('goods.appendage-goods.delete', { text: this.createLoggerParams(data) })
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/appendage/deleteAppendage`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功！')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		createLoggerParams (data) {
			let result
			let text1 = `适用门店：${data.allShopFlag === 1 ? '全部门店' : data.shopText}`
			let text2 = `适用客户：${data.allCustomerFlag === 1 ? '全部客户' : data.cusText}`
			let text3 = `生效条件：${data.type === 0 ? `订单金额大于等于${data.orderMoneyRule}元` : `下单主商品:${data.mainProductName}`}`
			let textArr = []
			let text = ''
			data.detail.forEach(item => {
				text = `【${item.appendageProductName}】,附属方式：${item.appendageType === 1 ? '按比例' : '固定值'},数值/比例：${item.mainQuantity}：${item.appendageQuantity},是否向上取整：${item.roundUpFlag === 1 ? '是' : '否'},是否为赠品：${item.giftFlag === 1 ? '是' : '否'}`
				textArr.push(text)
			})
			textArr.join(';')
			result = text1 + ',' + text2 + ',' + text3 + ',附属商品：' + textArr
			return result
		},
		getDetail (id) {
			window.sessionStorage.setItem('appendageId', id)
			this.$router.push('appendageDetail')
		},
		selectionChangeHandle (value) {
			let ids = value.map(item => {
				return item.id
			})
			this.ids = ids
		},
		handlePageChange (val) {
			this.page = val
			this.tableReload()
		},
		handleSizeChange (val) {
			this.size = val
			this.tableReload()
		},
		tableReload () {
			let params = {
				type: this.type,
				keyword: this.keyword,
				shopIds: this.shopIds,
				customerIds: this.customerIds,
				page: this.page,
				size: this.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/appendage/findAppendageList`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				this.totalCount = res.recordCount
			})
		},
		handleSearch (data) {
			this.customerIds = data.customerIds
			this.shopIds = data.shopIds
			this.type = data.type
			this.keyword = data.keyword
			this.tableReload()
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.appendageList-body {
	flex: 1
	display flex
	flex-direction column
	.btn-box1{
		height :40px;
		display :flex;
		align-items :center;
	}
	.table-box{
		flex:1
	}
	.page-box{
		height :40px;
		display :flex;
		justify-content :center;
		align-items :center
	}
}
</style>
<style lang="stylus">
	.cell{
		padding :0 !important
	}
.appendageList-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
